import React from 'react';

interface SpinnerProps {
  color?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ color = '#04709B' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      data-testid="spinner"
      className="animate-spin"
    >
      <circle
        cx="12.5"
        cy="12"
        r="11"
        stroke="#EEEEEE"
        strokeWidth="2"
        fill="transparent"
      />
      <mask
        id="mask0_16985_12917"
        style={{ maskType: 'alpha' }}
        x="12"
        y="0"
        width="13"
        height="12"
        maskUnits="userSpaceOnUse"
      >
        <path
          d="M12.5 0C14.0759 1.8792e-08 15.6363 0.310389 17.0922 0.913446C18.5481 1.5165 19.871 2.40042 20.9853 3.51472C22.0996 4.62903 22.9835 5.9519 23.5866 7.4078C24.1896 8.86371 24.5 10.4241 24.5 12L12.5 12V0Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask0_16985_12917)">
        <circle
          cx="12.5"
          cy="12"
          r="11"
          stroke={color}
          strokeWidth="2"
          fill="transparent"
        />
      </g>
    </svg>
  );
};
